import { render, staticRenderFns } from "./AppReferenceCard.vue?vue&type=template&id=054cda16"
import script from "./AppReferenceCard.vue?vue&type=script&lang=js"
export * from "./AppReferenceCard.vue?vue&type=script&lang=js"
import style0 from "./AppReferenceCard.vue?vue&type=style&index=0&id=054cda16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports